class ContractService
  constructor: ($http, $rootScope, $timeout, ConfigService) ->
    @$http                       = $http
    @$rootScope                  = $rootScope
    @$timeout                    = $timeout
    @ConfigService               = ConfigService
    @contracts                   = []
    @spouse_required             = false
    @can_download_contract       = false
    @show_payment_method_options = true
    @retries                     = 0
    @payment_agreement_retries   = 0
    @payment_agreement           = null
    @print_payment_agreement     = null
    @rbd_is_required             = true
    @rbd_consent                 = false
    @fetched_signed_contracts    = false
    @agreedToPaymentMethod       = null
  readyToViewContract: (customer_application_id) ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/can_view_contract_page"
    ).then((response) =>
      { data } = response
      @can_view_contract = data.can_view_contract
      @rbd_is_required = data.rbd_is_required
      @rbd_consent = data.rbd_consent
      @rbd_html  = data.rbd_html
      response
    )
  readyToDownloadContract: (customer_application_id) ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/can_download_contract"
    ).then((response) =>
      { data } = response
      @can_download_contract = data.can_download_contract
    )
  signedAllContracts: ->
    (@contracts.length isnt 0) and _.every(@contracts, (contract) -> contract.signed is true)
  getContracts: (customer_application_id) ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/contracts"
    ).then(@handleGetContractsSuccess, @handleGetContractsFailures)
  handleGetContractsSuccess: (response) =>
    { data } = response
    @contracts = data.contracts
    @spouse_required = data.spouse_required
    @show_payment_method_options = data.show_payment_method_options
    @print_contract_path = data.print_contract_path
    @downloadContractPaths = data.download_contract_paths
    @$rootScope.$broadcast "contracts:signed_all", @signedAllContracts()
    response
  handleGetContractsFailure: () =>
    if @retries >= 5
      alert("There was an error getting your contract, this is usually temporary.  We will try again in 5 seconds.")
    else
      @retries++
      @$timeout =>
        @getContracts(customer_application_id)
      , 5000
  # The following three methods are used for partners on contract manager
  getContract: (customer_application_id) ->
    promise = @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/contract"
    ).then(@handleGetContractSuccess, @handleGetContractFailure)
  handleGetContractSuccess: (response) =>
    { data } = response
    @contract_path = data.contract_path
    @contracts = data.contracts
    @spouse_required = data.spouse_required
    @show_payment_method_options = data.show_payment_method_options
    @print_contract_path = data.print_contract_path
    @download_contract_path = data.download_contract_path
    @$rootScope.$broadcast "contracts:signed_all", @signedAllContracts()
  handleGetContractFailure: () =>
    if @retries >= 5
      alert("There was an error getting your contract, this is usually temporary.  We will try again in 5 seconds.")
    else
      @retries++
      @$timeout =>
        @getContract(customer_application_id)
      , 5000
  signContracts: (customer_application_id, data) ->
    @$timeout =>
      @$rootScope.$broadcast 'customer_application:modal_message', "Loading..."
    , 500
    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/contracts"
      data: data
    )
  getSignedContracts: (customer_application_id) ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/contracts/details"
      ignoreLoadingBar: true
    ).then((response) =>
      { data } = response
      @fetched_signed_contracts = true
      @signed_contracts = data.signed_contracts
      @$rootScope.$broadcast "signed_contracts:data", data.signed_contracts
      response
    )
  getCachedSignedContracts: (customer_application_id) ->
    return if @fetched_signed_contracts
    @getSignedContracts(customer_application_id)
  getContractHtml: (contract) ->
    @$http(
      method: "GET"
      url: contract.link
      ignoreLoadingBar: true
    )
  getPaymentMethodAgreement: (customer_application_id) ->
    promise = @$http(
      method: "GET",
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/payment_method_agreement"
    ).then((response) =>
      { data } = response
      @payment_agreement = data.agreement_path
      @print_payment_agreement = data.print_agreement_path
      response
    )
    promise
  updatePaymentMethodAgreement: (customer_application_id, payment_method) ->
    @$http(
      method: "POST",
      data: { payment_method: payment_method }
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/payment_method_agreement"
    ).then((response) =>
      { data } = response
      @agreedToPaymentMethod = data.success
      response
    )

angular
.module("avant.contracts.services")
.service "ContractService", [
  "$http",
  "$rootScope",
  "$timeout",
  "ConfigService",
  ContractService
]

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = ContractService
  exports.ContractService = ContractService
else
  window.ContractService = ContractService
